/* Luce V2/V3 — scroll reveal. Re-runs on Shopify section re-render (theme editor). */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.luce-reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();
  document.addEventListener('shopify:section:load', reveal);
})();
